import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityMuestreadorState
} from './entity-muestreador.state';
import { entityMuestreadorAdapter } from './entity-muestreador.state';
import {
  entityMuestreadorLoadRequest,
  entityMuestreadorLoadSuccess,
  entityMuestreadorLoadFailure,
  entityMuestreadorAddFailure,
  entityMuestreadorAddRequest,
  entityMuestreadorAddSuccess,
  entityMuestreadorChangeFailure,
  entityMuestreadorChangeRequest,
  entityMuestreadorChangeSuccess,
  entityMuestreadorDeleteFailure,
  entityMuestreadorDeleteRequest,
  entityMuestreadorDeleteSuccess
} from './entity-muestreador.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityMuestreadorLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityMuestreadorLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityMuestreadorLoadSuccess, (state, { items }) =>
    entityMuestreadorAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityMuestreadorAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityMuestreadorAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityMuestreadorAddSuccess, (state, { item }) =>
    entityMuestreadorAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityMuestreadorChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityMuestreadorChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityMuestreadorChangeSuccess, (state, { item }) =>
    entityMuestreadorAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityMuestreadorDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityMuestreadorDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityMuestreadorDeleteSuccess, (state, { item }) =>
    entityMuestreadorAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function muestreadorReducer(
  state: EntityMuestreadorState | undefined,
  action: Action
) {
  return reducer(state, action);
}
